export default __webpack_public_path__ + "static/20922-Menu-accesories-4d9c228da5adc01f5f9b13f427937281.jpg";